'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Up;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Up(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      'aria-hidden': true,
      focusable: 'false',
      className: 'icon-svg-sort-up ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: 'currentColor', fillRule: 'evenodd', d: 'M14 8c0-1.08-.27-2.08-.81-3A6.063 6.063 0 0 0 11 2.81C10.08 2.27 9.08 2 8 2s-2.08.27-3 .81C4.08 3.35 3.35 4.08 2.81 5 2.27 5.92 2 6.92 2 8s.27 2.08.81 3c.54.92 1.27 1.65 2.19 2.19.92.54 1.92.81 3 .81s2.08-.27 3-.81c.92-.54 1.65-1.27 2.19-2.19.54-.92.81-1.92.81-3zm-3.484.702l-1.742-1.84v4.428a.56.56 0 0 1-.17.412.56.56 0 0 1-.41.169h-.388a.56.56 0 0 1-.41-.17.56.56 0 0 1-.17-.41V6.862L5.484 8.702a.574.574 0 0 1-.424.169.574.574 0 0 1-.423-.17l-.266-.266a.56.56 0 0 1-.17-.41.56.56 0 0 1 .17-.412l3.218-3.194A.56.56 0 0 1 8 4.25a.56.56 0 0 1 .411.17l3.218 3.193a.56.56 0 0 1 .17.411.56.56 0 0 1-.17.411l-.266.267a.574.574 0 0 1-.423.169.574.574 0 0 1-.424-.17z' })
  );
}

Up.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Sort/Up.js
// module id = 321
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15